export function Skeleton({ width = '100%', height = 20, radius = 8 }) {
  return (
    <div style={{
      width, height, borderRadius: radius,
      background: 'linear-gradient(90deg,#E2E8F0 25%,#F8FAFC 50%,#E2E8F0 75%)',
      backgroundSize: '200% 100%',
      animation: 'shimmer 1.5s infinite',
    }} />
  )
}

export function SkeletonCard() {
  return (
    <div style={{
      background: '#fff', borderRadius: 14, padding: 20,
      border: '1px solid #E2E8F0', borderLeft: '4px solid #E2E8F0',
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 14 }}>
        <Skeleton height={12} width="60%" radius={6} />
        <Skeleton height={36} width={36} radius="50%" />
      </div>
      <Skeleton height={28} width="80%" radius={6} />
      <div style={{ marginTop: 8 }}>
        <Skeleton height={10} width="40%" radius={6} />
      </div>
    </div>
  )
}

export function SkeletonTable({ rows = 5, cols = 5 }) {
  return (
    <div style={{ background: 'white', borderRadius: 14, overflow: 'hidden' }}>
      <div style={{ padding: '14px 20px', borderBottom: '1px solid #E2E8F0', display: 'flex', justifyContent: 'space-between' }}>
        <Skeleton width={200} height={32} />
        <Skeleton width={100} height={32} />
      </div>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr style={{ background: '#F8FAFC' }}>
            {Array.from({ length: cols }).map((_, i) => (
              <th key={i} style={{ padding: '11px 16px', borderBottom: '1px solid #E2E8F0' }}>
                <Skeleton height={10} width="80%" />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }).map((_, r) => (
            <tr key={r}>
              {Array.from({ length: cols }).map((_, c) => (
                <td key={c} style={{ padding: '13px 16px', borderBottom: '1px solid #E2E8F0' }}>
                  <Skeleton height={12} width={c === 0 ? '80%' : '60%'} />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default Skeleton
